import { __decorate } from "tslib";
import DaysBeforeOptions from '@/entities/enums/DaysBeforeOptions';
import { Component, Vue, Prop } from 'vue-property-decorator';
let CommonChartSettings = class CommonChartSettings extends Vue {
    constructor() {
        super(...arguments);
        this.DaysBeforeOptions = DaysBeforeOptions;
        this.selectedDayOption = DaysBeforeOptions.ONE;
    }
    mounted() {
        this.selectedDayOption = this.dayBeforeOption;
    }
    dayOptionChanged() {
        this.$emit('dayOptionSelected', this.selectedDayOption);
    }
};
__decorate([
    Prop({ type: Number })
], CommonChartSettings.prototype, "dayBeforeOption", void 0);
__decorate([
    Prop({ type: Boolean })
], CommonChartSettings.prototype, "componentIsLoading", void 0);
CommonChartSettings = __decorate([
    Component({ components: {} })
], CommonChartSettings);
export default CommonChartSettings;
